import Vue from 'vue'

export default () => {
  if (window.Stripe !== undefined) {
    const stripe = window.Stripe(process.env.STRIPE_KEY)
    Vue.prototype.$stripe = stripe
    Vue.prototype.$stripeElements = stripe.elements()
  }
}
